import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelperService } from "../../../lib/helper.service";

@Component({
	templateUrl: './friend_details.component.html'
})
export class FriendDetailsComponent extends InfoModalComponent {
	userList;
	translate;
	
	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
	) {
		super(activeModal);
	}
	
	ok() {
		this.close();
	}
}
